import { render, staticRenderFns } from "./thirdParty.vue?vue&type=template&id=24e2d930&scoped=true"
import script from "./thirdParty.vue?vue&type=script&lang=js"
export * from "./thirdParty.vue?vue&type=script&lang=js"
import style0 from "./thirdParty.vue?vue&type=style&index=0&id=24e2d930&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e2d930",
  null
  
)

export default component.exports